export default class Template8 {
  static getData() {
    return [];
  }
}
